/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R11_PurposeInputs */

const tr_cerez_s3_r11_purpose = /** @type {(inputs: Cerez_S3_R11_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet bağlantısıyla kayıt sayfasını açtığınızda yazılır; davet kodunun ilk girişinizde hesabınıza işlenmesi için (yerel depolama)`)
};

const en_cerez_s3_r11_purpose = /** @type {(inputs: Cerez_S3_R11_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written when you open the sign-up page through an invitation link; used to apply the invitation code to your account at your first sign-in (local storage)`)
};

const de_cerez_s3_r11_purpose = /** @type {(inputs: Cerez_S3_R11_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geschrieben, wenn Sie die Registrierungsseite über einen Einladungslink öffnen; dient der Übernahme des Einladungscodes in Ihr Konto bei der ersten Anmeldung (lokaler Speicher)`)
};

const ru_cerez_s3_r11_purpose = /** @type {(inputs: Cerez_S3_R11_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записывается, когда вы открываете страницу регистрации по ссылке-приглашению; служит для применения кода приглашения к вашей учётной записи при первом входе (локальное хранилище)`)
};

/**
* | output |
* | --- |
* | "Written when you open the sign-up page through an invitation link; used to apply the invitation code to your account at your first sign-in (local storage)" |
*
* @param {Cerez_S3_R11_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r11_purpose = /** @type {((inputs?: Cerez_S3_R11_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R11_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r11_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r11_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r11_purpose(inputs)
	return tr_cerez_s3_r11_purpose(inputs)
});